import { app, TransitionConfig } from './core/App';

import Boot from './scenes/Boot';
import Title from './scenes/Title';
import Intro from './scenes/Intro';
import PreloadCartoonito from './scenes/PreloadCartoonito';
import PreloadCartoonNetwork from './scenes/PreloadCartoonNetwork';
import MapLevelSelect from './scenes/MapLevelSelect';
import RelicSelect from './scenes/RelicSelect';
import Game from './scenes/Game';
import TransitionSceneToScene from './scenes/TransitionSceneToScene';
import TransitionLoadScene from './scenes/TransitionLoadScene';
import GameUI from './scenes/GameUI';
import DebugUI from './scenes/DebugUI';
import { RunSettings } from './level/RunSettingsHandler';

export const SceneId = {
  Boot: 'Boot',
  PreloadCartoonito: 'PreloadCartoonito',
  PreloadCartoonNetwork: 'PreloadCartoonNetwork',
  PlaceholderTitle: 'PlaceholderTitle',
  Title: 'Title',
  Intro: 'Intro',
  MapLevelSelect: 'MapLevelSelect',
  RelicSelect: 'RelicSelect',
  Game: 'Game',
  GameUI: 'GameUI',
  TransitionSceneToScene: 'TransitionSceneToScene',
  TransitionLoadScene: 'TransitionLoadScene',
  DebugUI: 'DebugUI'
} as const;

export const TransitionPoint = {
  BootEnd: 'BootEnd',
  // PreloadCartoonitoEnd: 'PreloadCartoonitoEnd',
  // PreloadCartoonNetworkEnd: 'PreloadCartoonNetworkEnd',
  PreloadEnd: 'PreloadEnd',
  TitleEnd1: 'TitleEnd1',
  TitleEnd2: 'TitleEnd2',
  IntroBack: 'IntroBack',
  IntroEnd: 'IntroEnd',
  MapBack: 'MapBack',
  MapEnd: 'MapEnd',
  RelicSelectBack: 'RelicSelectBack',
  RelicSelectEnd: 'RelicSelectEnd',
  GameBack: 'GameBack',
  GameHome: 'GameHome',
  GameMap: 'GameMap',
  GameReplay: 'GameReplay'
} as const;

export const scenes = [Boot, PreloadCartoonNetwork, Title, Intro, MapLevelSelect, RelicSelect, Game, GameUI, TransitionSceneToScene, TransitionLoadScene, DebugUI];

// Rooting table.
const sceneMap: Map<keyof typeof TransitionPoint, keyof typeof SceneId | TransitionConfig> = new Map();
sceneMap.set(TransitionPoint.BootEnd, SceneId.PreloadCartoonNetwork);
sceneMap.set(TransitionPoint.PreloadEnd, SceneId.Title);
sceneMap.set(TransitionPoint.TitleEnd1, { nextScene: SceneId.Intro, transitionScene: SceneId.TransitionSceneToScene, transitionTime: 1000, waitForPreload: false });
// sceneMap.set(TransitionPoint.TitleEnd2, { nextScene: SceneId.MapLevelSelect, transitionScene: SceneId.TransitionSceneToScene, transitionTime: 1000 });
sceneMap.set(TransitionPoint.IntroBack, { nextScene: SceneId.Title, transitionScene: SceneId.TransitionSceneToScene, transitionTime: 1000, waitForPreload: false });
sceneMap.set(TransitionPoint.IntroEnd, { nextScene: SceneId.MapLevelSelect, transitionScene: SceneId.TransitionSceneToScene, transitionTime: 1000, waitForPreload: false });
sceneMap.set(TransitionPoint.MapBack, { nextScene: SceneId.Title, transitionScene: SceneId.TransitionLoadScene, transitionTime: 1000, waitForPreload: true });
sceneMap.set(TransitionPoint.MapEnd, { nextScene: SceneId.RelicSelect, transitionScene: SceneId.TransitionSceneToScene, transitionTime: 1000, waitForPreload: false });
sceneMap.set(TransitionPoint.RelicSelectBack, { nextScene: SceneId.MapLevelSelect, transitionScene: SceneId.TransitionLoadScene, transitionTime: 1000, waitForPreload: true });
sceneMap.set(TransitionPoint.RelicSelectEnd, { nextScene: SceneId.Game, transitionScene: SceneId.TransitionSceneToScene, transitionTime: 1000, waitForPreload: false });
sceneMap.set(TransitionPoint.GameBack, { nextScene: SceneId.MapLevelSelect, transitionScene: SceneId.TransitionLoadScene, transitionTime: 1000, waitForPreload: true });
sceneMap.set(TransitionPoint.GameMap, { nextScene: SceneId.MapLevelSelect, transitionScene: SceneId.TransitionLoadScene, transitionTime: 1000, waitForPreload: true });
sceneMap.set(TransitionPoint.GameReplay, { nextScene: SceneId.RelicSelect, transitionScene: SceneId.TransitionSceneToScene, transitionTime: 1000, waitForPreload: false });

app.updateSceneMap(sceneMap as unknown as Map<string, string>, TransitionPoint.PreloadEnd.toString());

export interface SceneData {
  sourceScene: keyof typeof SceneId;
  sourceTransition?: keyof typeof TransitionPoint;
  transitionData?: TransitionSceneData;
  gameSceneData?: GameSceneData;
  runSettings?: Partial<RunSettings>;
  [key: string]: any;
}

export interface TransitionSceneData {
  sourceScene: string;
  nextScene: string;
}

export interface GameSceneData {
  shouldSkip: boolean;
}
